export enum SIGN_IN {
    /**
     * @value Password
     */
    ADMIN_USER_DIRECTORY_PASSWORD = 'LOGIN_PASSWORD',
    /**
     * @value Check your email
     */
    CHECK_YOUR_EMAILS = 'CHECK_YOUR_EMAILS',
    /**
     * @value Confirm password
     */
    CONFIRM_PASSWORD = 'CONFIRM_PASSWORD',
    /**
     * @value Email address or username
     */
    EMAIL_ADDRESS_OR_USERNAME = 'SIGN_IN.EMAIL_ADDRESS_OR_USERNAME',
    /**
     * @value Enter your credentials
     */
    ENTER_CREDENTIALS = 'ENTER_CREDENTIALS',
    /**
     * @value Enter your email address to reset your password
     */
    ENTER_EMAIL_TO_RESET_PASSWORD = 'ENTER_EMAIL_TO_RESET_PASSWORD',
    /**
     * @value Forgot your password?
     */
    FORGOT_YOUR_PASSWORD = 'FORGOT_YOUR_PASSWORD',
    /**
     * @value Trace ID: %CORRELATION_ID%
     */
    GENERIC_ERROR = 'LOGIN.GENERIC_ERROR',
    /**
     * @value Unable to login.
     */
    GENERIC_ERROR_LOGIN = 'LOGIN.GENERIC_ERROR_LOGIN',
    /**
     * @value Invalid CAPTCHA, try again.
     */
    INVALID_CAPTCHA = 'LOGIN.INVALID_CAPTCHA',
    /**
     * @value Use a valid email address or username
     */
    INVALID_EMAIL_ADDRESS_OR_USERNAME = 'SIGN_IN.INVALID_EMAIL_ADDRESS_OR_USERNAME',
    /**
     * @value Use a valid email address
     */
    INVALID_EMAIL_ERROR = 'ERROR_INVALID_EMAIL_ADDRESS',
    /**
     * @value Invalid credentials.
     */
    INVALID_LOGIN = 'LOGIN.INVALID_LOGIN',
    /**
     * @value Login timeout, try again.
     */
    INVALID_LOGIN_SESSION_EXPIRED = 'LOGIN.INVALID_LOGIN_SESSION_EXPIRED',
    /**
     * @value Invalid SAML configuration, check your SAML setup.
     */
    INVALID_SAML_CONFIGURATION = 'LOGIN.INVALID_SAML_CONFIGURATION',
    /**
     * @value To view this page, log in.
     */
    NEED_LOGIN = 'LOGIN.NEED_LOGIN',
    /**
     * @value New password
     */
    NEW_PASSWORD = 'NEW_PASSWORD',
    /**
     * @value Your account is not authorized to access this page. Try using a different account or requesting access to the page from a site administrator.
     */
    NOT_AUTHORIZED_LOGIN = 'LOGIN.NOT_AUTHORIZED_LOGIN',
    /**
     * @value Not enough characters
     */
    NOT_ENOUGH_CHARACTERS = 'NOT_ENOUGH_CHARACTERS',
    /**
     * @value Unable to update password.
     */
    PASSWORD_API_UPDATE_ERROR = 'LOGIN.PASSWORD_API_UPDATE_ERROR',
    /**
     * @value Must contain more than 8 characters
     */
    PASSWORD_NOT_ENOUGH_CHARACTERS = 'PASSWORD_NOT_ENOUGH_CHARACTERS',
    /**
     * @value Passwords don't match
     */
    PASSWORD_RESET_DO_NOT_MATCH = 'PASSWORD_RESET_DO_NOT_MATCH',
    /**
     * @value Reset your password
     */
    RESET_YOUR_PASSWORD = 'RESET_YOUR_PASSWORD',
    /**
     * @value Less login options
     */
    SHOW_LESS_LOGIN_OPTIONS = 'LOGIN.SHOW_LESS_LOGIN_OPTION',
    /**
     * @value More login options
     */
    SHOW_MORE_LOGIN_OPTIONS = 'LOGIN.SHOW_MORE_LOGIN_OPTION',
    /**
     * @value Sign in with email
     */
    SIGN_IN_WITH_LUMAPPS = 'SIGN_IN_WITH_LUMAPPS',
    /**
     * @value Too many login attempts, try again in a few minutes.
     */
    TOO_MANY_ATTEMPTS = 'LOGIN.TOO_MANY_ATTEMPTS',
    /**
     * @value Unable to create user.
     */
    USER_CREATION_FAILED = 'LOGIN.ERROR_USER_CREATION_FAILED',
    /**
     * @value Welcome to LumApps
     */
    WELCOME = 'FRONT.TOP_USER_BENEFITS.WELCOME_TITLE',
    /**
     * @value How would you like to log in?
     */
    WELCOME_LOGIN_OPTIONS_SUBTITLE = 'WELCOME_LOGIN_OPTIONS_SUBTITLE',
}
export enum LOGOUT {
    /**
     * @value You have been signed out of LumApps.<br>
     * To sign out of your Google account, <a href="https://accounts.google.com/logout">click here</a>.
     */
    GOOGLE = 'LOGIN_LOGOUT_GOOGLE',
    /**
     * @value You have been signed out of LumApps.<br>
     * To sign out of your Microsoft account, <a href="https://login.microsoftonline.com/logout.srf">click here</a>.
     */
    MICROSOFT = 'LOGIN_LOGOUT_MICROSOFT',
    /**
     * @value You have been signed out of LumApps.<br>
     * To sign out of your Okta account, <a href="%LOGOUT_URL%">click here</a>.
     */
    OKTA = 'LOGIN_LOGOUT_OKTA',
}
